export const USER_DOCUMENTS_EDITOR = 'precedent-editor'
export const USER_CONTENT_MANAGER = 'content-manager'
export const USER_TAKEOVER_EDITOR = 'takeover-editor'
export const USER_TAKEOVER_PUBLISHER = 'takeover-publisher'
export const USER_LITE = 'lite'
export const USER_PREMIUM = 'premium'
export const USER_CLARILIS = 'clarilis'
export const USER_CLARILIS_SHARES = 'clarilis-shares'
export const USER_DOC_DRAFTER = 'docdrafter'
export const USER_DOC_DRAFTER_CORP = 'docdrafter-corporate'
export const USER_DOC_DRAFTER_EMP = 'docdrafter-employment'
export const USER_DOCUMENTS = 'documents'
